import { Component, Input, OnInit } from '@angular/core';
import { trackByRoute } from '../../utils/track-by';
import { NavigationService } from '../../services/navigation.service';
import icRadioButtonChecked from '@iconify/icons-ic/twotone-radio-button-checked';
import icRadioButtonUnchecked from '@iconify/icons-ic/twotone-radio-button-unchecked';
import { LayoutService } from '../../services/layout.service';
import { ConfigService } from '../../services/config.service';
import { map } from 'rxjs/operators';
import { Tools } from '@app/utilities/tools';

@Component({
	selector: 'vex-sidenav',
	templateUrl: './sidenav.component.html',
	styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent {
	@Input() collapsed: boolean;
	public version: string = this.tools.getVersion();
	public deploymentTime: string = this.tools.getDeploymentTime();
	collapsedOpen$ = this.layoutService.sidenavCollapsedOpen$;
	title$ = this.configService.config$.pipe(map(config => config.sidenav.title));
	imageUrl$ = this.configService.config$.pipe(map(config => config.sidenav.imageUrl));
	showCollapsePin$ = this.configService.config$.pipe(
		map(config => config.sidenav.showCollapsePin),
	);

	trackByRoute = trackByRoute;
	icRadioButtonChecked = icRadioButtonChecked;
	icRadioButtonUnchecked = icRadioButtonUnchecked;

	constructor(
		public navigationService: NavigationService,
		private layoutService: LayoutService,
		private configService: ConfigService,
		private tools: Tools,
	) {}

	onMouseEnter() {
		this.layoutService.collapseOpenSidenav();
	}

	onMouseLeave() {
		this.layoutService.collapseCloseSidenav();
	}

	toggleCollapse() {
		this.collapsed ? this.layoutService.expandSidenav() : this.layoutService.collapseSidenav();
	}
}
